import { VerticalContainer } from '@american-autonomy/ag-ui';

import SliderField from 'components/SliderField';
import Toggle from 'components/Toggle';
import LabelText from 'components/text/LabelText';

import {
    LABEL,
    TEST_ID,
    WIND_DEFAULT,
    WIND_MAX,
    WIND_MIN,
    WIND_NONE_INDEX,
    WIND_OPTIONS,
    WIND_SET_INDEX,
    WIND_SET_VALUE,
    WIND_STEP,
    WIND_UNIT
} from './constants';
import type { FunctionComponent, NumericChangeParams, Props } from './types';

import styles from './styles.module.scss';

const WindDirectionControl: FunctionComponent<Props> = ({
    className = '',
    onChange,
    testId = TEST_ID,
    value
}) => {
    const isSetMode = value !== null;
    const activeIndex = isSetMode ? WIND_SET_INDEX : WIND_NONE_INDEX;
    const sliderValue = value ?? WIND_DEFAULT;

    const handleModeClick = (option: string) => {
        if (option === WIND_SET_VALUE) {
            onChange({ windFromDegrees: WIND_DEFAULT });

            return;
        }

        onChange({ windFromDegrees: null });
    };

    const handleSliderChange = ({ value: nextValue }: NumericChangeParams) => {
        onChange({ windFromDegrees: nextValue });
    };

    return (
        <VerticalContainer
            className={`${className} ${styles.windDirectionControl}`}
            testId={testId}>
            <LabelText text={LABEL} />

            <Toggle activeIndex={activeIndex} onClick={handleModeClick} options={WIND_OPTIONS} />

            {isSetMode && (
                <SliderField
                    label={LABEL}
                    max={WIND_MAX}
                    min={WIND_MIN}
                    onChange={handleSliderChange}
                    step={WIND_STEP}
                    unit={WIND_UNIT}
                    value={sliderValue}
                />
            )}
        </VerticalContainer>
    );
};

export default WindDirectionControl;
